/**
 * Returns `true` when `el` is (or is inside) an interactive element
 * such as a button, link, or form control. Used by click-to-advance
 * wrappers to avoid double-firing when the user clicks a CTA.
 */
export const isInteractive = (el: EventTarget | null): boolean => {
  if (!(el instanceof Element)) return false;
  const tag = el.tagName;
  if (tag === "BUTTON" || tag === "A" || tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT")
    return true;
  return el.closest("button, a, input, textarea, select, [role=button]") !== null;
};
